import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/apiClient";

// xcelio.app/michael → the home page carrying Michael's code.
export default function PartnerLink() {
  const { slug } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const ch = new URLSearchParams(window.location.search).get("ch");
    api.get(`/p/${encodeURIComponent(slug)}`)
      .then((r) => navigate(`/?ref=${r.data.code}${ch ? `&ch=${encodeURIComponent(ch)}` : ""}`, { replace: true }))
      .catch(() => navigate("/", { replace: true }));
  }, [slug, navigate]);
  return <div className="min-h-screen flex items-center justify-center" data-testid="partner-link-page"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
}
